<template>
  <div>
    <div>
      <i18n
        tag="p"
        class="Fuell-Text"
        path="transactions_reimbursements_history_expenses_explanation"
        v-if="expenses"
      >
      </i18n>
      <i18n
        tag="p"
        class="Fuell-Text"
        path="transactions_reimbursements_history_explanation"
        v-else-if="!expenses && !$route.params.userId"
      ></i18n>
      <i18n
        tag="p"
        class="Fuell-Text"
        path="transactions_reimbursements_userId_history_explanation"
        v-else-if="!expenses && $route.params.userId"
      >
        <template v-slot:userName>
          <span class="text-primary">{{ userName }}</span>
        </template>
      </i18n>
    </div>
    <div class="Fuell-Toolbar justify-content-between">
      <div class="d-flex toolbar-column">
        <entity-search-input @search="fetchTransactions"></entity-search-input>
        <date-select-reference type="expense"></date-select-reference>
        <div class="d-flex flex-row">
          <button
            @click="showFilterModal"
            class="Fuell-ToolbarButton"
          >
            <span class="Fuell-ToolbarButton--icon">
              <img
                :src="require('@/assets/img/icons/icon-filter.svg')"
                alt="filter"
              />
            </span>
            <span class="Fuell-ToolbarButton--label">
              {{ $t('FILTERS') }}
            </span>
            <span
              class="Fuell-ToolbarButton--badge"
              v-if="filtersAmount"
              aria-hidden="true"
            >
              {{ filtersAmount }}
            </span>
          </button>
          <span
            class="Fuell-ToolbarButton remove-container"
            v-if="filtersAmount > 0"
            @click.prevent.stop="resetFilters"
          >
            <inline-svg
              style="height:10px;"
              :src="require('@/assets/img/icons/close-menu.svg')"
              alt="remove-filters"
            />
          </span>
        </div>
      </div>
      <div class="d-flex toolbar-column">
        <transactions-view-group
          v-if="$route.meta.viewGroup"
          :activeView.sync="activeView"
          @changeView="changeView"
        ></transactions-view-group>

        <button
          class="Fuell-ToolbarButton ml-3"
          @click="showAccountingClosureModal"
          v-if="!isUser && !isSuperBook && !expenses"
        >
          <span class="Fuell-ToolbarButton--icon">
            <img
              :src="require('@/assets/img/icons/icon-agencia-tributaria.svg')"
              alt="columns"
            />
          </span>
          <span
            class="Fuell-ToolbarButton--label"
            v-t="{ path: 'transactions_action_close_accounting_periods' }"
          >
          </span>
        </button>
        <div
          class="d-flex flex-column"
          v-if="!isSuperBook && expenses"
        >
          <div class="relative">
            <div class="Fuell-ToolbarButton blue dropdown--container">
              <span class="Fuell-ToolbarButton--label d-flex justify-content-center align-items-center mt-2">{{
                $t('transactions_actions_add_expense') }}</span>

              <ul class="dropdown--content">
                <li
                  class="clickable"
                  v-if="(isAdmin || isUser)"
                  @click="showCreateExpenseModal"
                >
                  <img
                    alt="expense"
                    class="icon"
                    :src="require('@/assets/img/icons/icon-receipt.svg')"
                  >
                  <span v-t="{ path: 'transactions_actions_create_expense' }"> </span>
                </li>

                <li
                  class="clickable"
                  @click="showCreateMileageModal"
                >
                  <img
                    alt="mileage"
                    class="icon"
                    :src="require('@/assets/img/icons/icon-mileage.svg')"
                  >
                  <span
                    class="clickable"
                    v-t="{ path: 'transactions_actions_create_mileage' }"
                  ></span>

                </li>
                <li
                  class="clickable"
                  @click="showDietModal"
                >
                  <img
                    class="icon icon-diet mt-1"
                    alt="diet"
                    :src="require('@/assets/img/icons/icon-diets.jpg')"
                  >
                  <span
                    class="clickable"
                    v-t="{ path: 'transactions_actions_create_diet' }"
                  ></span>
                </li>

              </ul>
            </div>
          </div>

        </div>

        <button
          class="Fuell-ToolbarButton ml-3 blue"
          @click="showExportModal"
          v-if="!isSuperBook"
        >
          <span
            class="Fuell-ToolbarButton--label"
            v-t="{ path: expenses ? 'transactions_action_download' : 'transactions_action_export' }"
          >
          </span>
        </button>

      </div>
    </div>
    <quick-filter-container v-if="!initializing">
      <template slot="content">

        <transactions-review-info-bar
          v-if="!initializing"
          class="Fuell-Transactions--review-info-bar"
          :expenses="expenses"
          :defaultFilters="defaultFilters"
          @close="closeTransactionMissingInfoBar"
          @resetFilters="resetFilters"
        />

        <template v-for="filteredView in filteredViews">
          <quick-filter-button
            :quickFilter="filteredView"
            :key="filteredView.id"
            @setFilteredView="setCurrentViewFilters"
            @removeFilteredView="handleRemoveFilteredView(filteredView.id)"
            @editFilteredView="handleEditFilteredView(filteredView.id)"
            :isActive="checkCurrentFilteredView(filteredView.id)"
          />
        </template>

      </template>
    </quick-filter-container>

    <transactions-table
      :tableName="tableName"
      :columns="columns"
      :showSelect="showTransactionSelect"
      :actionsList="actionsList"
      columsSelector
      @showReceiptModal="showReceiptModal"
      @showDetailTransactionModal="showTransactionModal"
      @showMileageModal="showCreateMileageModal"
      @showDietModal="showDietModal"
      @showTransactionModal="showTransactionModal"
      @goToPendingTransactions="goToPendingTransactions"
      @goToRefundableTransactions="goToRefundableTransactions"
      @goToNotRefundableTransactions="goToNotRefundableTransactions"
    ></transactions-table>
    <transactions-filter-modal
      v-if="showFilterModalFlag"
      :open.sync="showFilterModalFlag"
      :expenses="expenses"
      :quickFilterId="filteredViewIdToEdit"
      @resetTransactionsFilters="fetchTransactions($event)"
      @reviewStatusFilterSelected="incrementReviewStatusFilterCounter"
      @removeFilteredView="handleRemoveFilteredView"
    >
    </transactions-filter-modal>
    <transaction-receipts-viewer-modal
      :open.sync="showTransactionReceiptModalFlag"
      v-if="showTransactionReceiptModalFlag"
      :transactionId.sync="transactionToShowReceiptId"
      :preloadReceiptId="preloadReceiptId"
    >
    </transaction-receipts-viewer-modal>

    <transactions-export-modal
      v-if="showTransactionExportModalFlag"
      :downloadMode="expenses"
      :isReimbursement="expenses"
      showFilters
      :extraFilters="extraFilters"
      :open.sync="showTransactionExportModalFlag"
      :transactionStatus="'OK'"
      :defaultTab="defaultExportTab"
      @showTransactionFiltersModal="showFilterModal"
      @resetFilters="resetFilters"
      @closeModal="removeHash"
    ></transactions-export-modal>

    <accounting-periods-closure-modal
      :open.sync="showAccountingClosureModalFlag"
      v-if="showAccountingClosureModalFlag"
    ></accounting-periods-closure-modal>
    <create-expense-modal
      v-if="showCreateExpenseModalFlag"
      :transactionId.sync="transactionToEditId"
      :open.sync="showCreateExpenseModalFlag"
      @expenseCreated="fetchTransactions"
      @showReceiptModal="showReceiptModal"
      @confirmDelete="showConfirmDeleteTransactionModal"
      @closeModal="handleCloseTransactionReceiptModal"
      @reviewStatusChanged="closeModals"
      @showTransactionModal="showTransactionModal"
    ></create-expense-modal>
    <create-mileage-modal
      v-if="showCreateMileageModalFlag"
      :open.sync="showCreateMileageModalFlag"
      :transactionId.sync="transactionToEditId"
      @showReceiptModal="showReceiptModal"
      @confirmDelete="showConfirmDeleteTransactionModal"
      @expenseCreated="fetchTransactions"
      @closeModal="handleCloseTransactionReceiptModal"
      @reviewStatusChanged="closeModals"
      @showTransactionModal="showTransactionModal"
    ></create-mileage-modal>
    <create-diet-modal
      v-if="showCreateDietModalFlag"
      :open.sync="showCreateDietModalFlag"
      :transactionId.sync="transactionToEditId"
      @expenseCreated="fetchTransactions"
      @showReceiptModal="showReceiptModal"
      @confirmDelete="showConfirmDeleteTransactionModal"
      @closeModal="handleCloseTransactionReceiptModal"
      @reviewStatusChanged="closeModals"
      @showTransactionModal="showTransactionModal"
    />
    <diet-detail-modal
      v-if="showDetailDietModalFlag"
      :open.sync="showDetailDietModalFlag"
      :transactionId.sync="transactionToEditId"
      @showReceiptModal="showReceiptModal"
      @showEditTransactionModal="showEditionTransactionModal(transactionToEditId, 'diet')"
      @confirmDelete="showConfirmDeleteTransactionModal"
      @showTransactionModal="showTransactionModal"
    ></diet-detail-modal>
    <mileage-detail-modal
      v-if="showDetailMileageModalFlag"
      :open.sync="showDetailMileageModalFlag"
      :transactionId.sync="transactionToEditId"
      @showReceiptModal="showReceiptModal"
      @showEditTransactionModal="showEditionTransactionModal(transactionToEditId, 'mileage')"
      @confirmDelete="showConfirmDeleteTransactionModal"
      @showTransactionModal="showTransactionModal"
    ></mileage-detail-modal>
    <transaction-detail-modal
      v-if="showDetailTransactionModalFlag"
      :open.sync="showDetailTransactionModalFlag"
      :transactionId.sync="transactionToEditId"
      @showReceiptModal="showReceiptModal"
      @showEditTransactionModal="showEditionTransactionModal(transactionToEditId, 'expense')"
      @confirmDelete="showConfirmDeleteTransactionModal"
      @showTransactionModal="showTransactionModal"
    ></transaction-detail-modal>
    <transaction-receipts-viewer-modal
      v-if="showExpenseReceiptPreviewModalFlag"
      :id="'expense-receipt-preview-modal'"
      :preloadReceiptId="preloadReceiptId"
      :open.sync="showExpenseReceiptPreviewModalFlag"
      :expenseMode="receiptsModalExpenseMode"
      :expenseType="expenseType"
    >
    </transaction-receipts-viewer-modal>
    <confirm-modal
      v-if="showConfirmRemoveQuickFilterModalFlag"
      :open.sync="showConfirmRemoveQuickFilterModalFlag"
      :title="$t('transactions_filter_remove_quick_filter_modal_header')"
      :acceptText="$t('transactions_filter_remove_quick_filter_modal_confirm_action')"
      :message="$t('transactions_filter_remove_quick_filter_modal_info')"
      modalClass="ModalBox--400"
      @accept="removeFilteredView"
    >
    </confirm-modal>
    <confirm-modal
      v-if="showConfirmDeleteTransactionModalFlag"
      :title="'ACTION_REMOVE'"
      :acceptText="'ACTION_REMOVE'"
      @dismiss="showConfirmDeleteTransactionModalFlag = false"
      @accept="deleteTransaction"
    ></confirm-modal>
  </div>
</template>
<script>
import { REVIEW_STATUS, BULK_FUNNEL_ACTIONS } from '@/constants/reviewStatus'
import _transactionsIndexViewShared from '../../../_mixins/_transactionsIndexViewShared'
import _revissionFunnelActions from '../../../_mixins/funnel/_revissionFunnelActionsMixin'
import EntitySearchInput from '@/components/Commons/Search/EntitySearchInput'
import TransactionsReviewInfoBar from '../../../_components/_shared/TransactionsReviewInfoBar.vue'
import InlineSvg from 'vue-inline-svg'
import { segmentTrack } from '@/analytics/segment'
import DateSelectReference from '../../../../../components/Commons/Forms/DateSelectReference.vue'
import transactionPeriodsMixin from '@/modules/transactions/_mixins/_transactionPeriods'
import TransactionsViewGroup from '@/modules/transactions/_components/_shared/TransactionsViewGroup.vue'
const TransactionDetailModal = () => import('../../../_components/_shared/TransactionsDetailModal')
const TransactionsExportModal = () => import('../../../_components/_shared/TransactionsExportModal')
const AccountingPeriodsClosureModal = () => import('@/modules/accounting/_components/AccountingPeriodsClosureModal')
const MileageDetailModal = () => import('../../../_components/expenses/MileageDetailModal')
const DietDetailModal = () => import('../../../_components/expenses/DietDetailModal')
const CreateExpenseModal = () => import('../../../_components/expenses/CreateExpenseModal')
const CreateMileageModal = () => import('../../../_components/expenses/CreateMileageModal')
const CreateDietModal = () => import('../../../_components/expenses/CreateDietModal')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'ReimbursementsHistory',
  props: {
    expenses: {
      type: Boolean,
      default: false
    },
    hideReviewInfo: {
      type: Boolean,
      default: true
    },
    hideMissingInfo: {
      type: Boolean,
      default: false
    },
    users: {
      type: Boolean,
      default: false
    },
    user: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    _transactionsIndexViewShared,
    _revissionFunnelActions,
    transactionPeriodsMixin
  ],
  components: {
    TransactionsExportModal,
    EntitySearchInput,
    AccountingPeriodsClosureModal,
    CreateExpenseModal,
    CreateMileageModal,
    CreateDietModal,
    ConfirmModal,
    InlineSvg,
    TransactionsReviewInfoBar,
    DateSelectReference,
    TransactionsViewGroup,
    TransactionDetailModal,
    MileageDetailModal,
    DietDetailModal
  },
  data () {
    return {
      showTransactionExportModalFlag: false,
      showAccountingClosureModalFlag: false,
      showExpenseReceiptPreviewModalFlag: false,
      expenseMode: false,
      expenseType: '',
      defaultExportTab: 'EXPORT',
      multipleActionsValue: '',
      multipleActionsLockFlag: false,
      extraFilters: {
        exportTypeCode: 'DOWNLOAD',
        downloadTypeCode: 'EXPENSES_REFUNDS'
      },
      tableName: 'reimbursements',
      activeView: 'default',
      actionsList: [
        BULK_FUNNEL_ACTIONS.LOCK,
        BULK_FUNNEL_ACTIONS.UNLOCK,
        BULK_FUNNEL_ACTIONS.APPROVE,
        BULK_FUNNEL_ACTIONS.REJECT,
        BULK_FUNNEL_ACTIONS.ACCOUNT
      ]
    }
  },
  computed: {
    userName () {
      if (this.$route.params.userId) {
        let list = this.$store.getters['TransactionsStore/users'].length > 0 ? this.$store.getters['TransactionsStore/users'] : this.$store.getters['TransactionsStore/transactions']
        const user = list.find(el => el.card?.user?.id === Number.parseInt(this.$route.params.userId) || el.user_id === Number.parseInt(this.$route.params.userId))
        if (user) {
          return user.user_first_name ? `${user.user_first_name} ${user.user_last_name}` : `${user.card.user.firstName} ${user.card.user.lastName}`
        }
      }
      return ''
    },
    canReviewTransactions () {
      return this.$store.getters['LoginStore/isAdmin'] || this.$store.getters['LoginStore/isBookKeeper'] || (this.$store.getters['LoginStore/isUser'] && (this.$store.getters['LoginStore/isOwnerOfAnyBudget'] || this.$store.getters['LoginStore/isReviewer']))
    },
    canRejectTransactions () {
      return this.$store.getters['LoginStore/isAdmin'] || this.$store.getters['LoginStore/isBookKeeper'] || (this.$store.getters['LoginStore/isUser'] && (this.$store.getters['LoginStore/isOwnerOfAnyBudget'] || this.$store.getters['LoginStore/isReviewer']))
    },
    BULK_FUNNEL_ACTIONS () {
      return BULK_FUNNEL_ACTIONS
    },
    filters () {
      return { ...this.$store.getters['TransactionsStore/filters'] }
    },
    defaultFilters () {
      let defaultFilters = {
        'status.code': ['OK'],
        'order[id]': 'DESC',
        'type.code': 'EXPENSE',
        ...this.periods.find(el => el.default).filter,
        'card.user.id': this.$route.params.userId
      }

      if (this.expenses) {
        defaultFilters['card.user.id'] = this.loggedUserId
        defaultFilters['reviewStatus.code'] = [REVIEW_STATUS.DRAFT, REVIEW_STATUS.AWAITING_REVIEW, REVIEW_STATUS.CANCELLED, REVIEW_STATUS.APPROVED, REVIEW_STATUS.OFFICE_FLOW_REVISION]
      } else {
        defaultFilters['reviewStatus.code'] = [REVIEW_STATUS.AWAITING_REVIEW, REVIEW_STATUS.CANCELLED, REVIEW_STATUS.APPROVED, REVIEW_STATUS.OFFICE_FLOW_REVISION]
      }

      return defaultFilters
    }
  },
  methods: {
    goToPendingTransactions (event) {
      this.$router.push({
        name: 'reimbursements_history_user_id',
        params: { userId: event }
      })
    },
    goToRefundableTransactions (event) {
      this.$router.push({
        name: 'reimbursements_history_user_id',
        params: { userId: event },
        query: { 'expense.paymentMethod.officePaymentMethod.repayable': true }
      })
    },
    goToNotRefundableTransactions (event) {
      this.$router.push({
        name: 'reimbursements_history_user_id',
        params: { userId: event },
        query: { 'expense.paymentMethod.officePaymentMethod.repayable': false }
      })
    },
    changeView (view) {
      this.$router.push({
        name: view === 'users' ? 'reimbursements_history_users' : 'reimbursements_history'
      })
    },
    async fetchTransactions (event) {
      let defaultFilters = {
        'status.code': ['OK'],
        'order[id]': 'DESC',
        'type.code': 'EXPENSE',
        ...this.periods.find(el => el.default).filter,
        'card.user.id': this.$route.params.userId
      }
      if (this.filters['date[after]'] || this.filters['date[after]'] === null) {
        defaultFilters['date[after]'] = this.filters['date[after]']
      }
      if (this.filters['date[before]'] || this.filters['date[before]'] === null) {
        defaultFilters['date[before]'] = this.filters['date[before]']
      }

      if (this.expenses) {
        defaultFilters['card.user.id'] = this.loggedUserId
        defaultFilters['reviewStatus.code'] = [REVIEW_STATUS.DRAFT, REVIEW_STATUS.AWAITING_REVIEW, REVIEW_STATUS.CANCELLED, REVIEW_STATUS.APPROVED, REVIEW_STATUS.OFFICE_FLOW_REVISION]
      } else {
        defaultFilters['reviewStatus.code'] = [REVIEW_STATUS.AWAITING_REVIEW, REVIEW_STATUS.CANCELLED, REVIEW_STATUS.APPROVED, REVIEW_STATUS.OFFICE_FLOW_REVISION]
      }
      let searchFilters = {}
      let force = false
      if (event && event.length >= 3) {
        searchFilters.query = event
      }
      let filters = event ? { ...defaultFilters, ...searchFilters } : { ...defaultFilters, ...searchFilters, ...this.parseQueryParams() }
      if (event && event.force) {
        force = true
      }
      await this.$store.dispatch('TransactionsStore/setTransactionsFilters', {
        filters: filters,
        force: force
      })
      this.$store.dispatch('TransactionsStore/setUserSelectedFiltersAmount', this._countFilters(filters))
      if (!event) {
        await this.$store.dispatch('TransactionsStore/fetchTransactionDashboard')
      }
      if (searchFilters.query) {
        segmentTrack('Transaction filtered view', {
          search: true
        })
      }
    }
  },
  mounted () {
    let defaultFilters = { ...this.defaultFilters, 'iCanReview': true }
    if (this.$route.name === 'my_pending_reimbursements' || this.$route.name === 'my_history_reimbursements') {
      delete defaultFilters['iCanReview']
    }
    this.$store.dispatch('TransactionsStore/fetchTransactionsWithoutFiltersDashboard', defaultFilters)
  }
}
</script>
<style src="@/assets/styles/multiselect/multiselect-section-selector.css" scoped></style>
<style lang="scss" src="@/assets/styles/dropdown/dropdowns.scss" scoped></style>
<style lang="scss" scoped>
.Fuell-Transactions--review-info-bar:nth-child(even) {
  margin-left: 24px;
}

@media screen and (max-width: 576px) {
  .Fuell-Transactions--review-info-bar {
    margin: 10px 0px !important;
  }
}
</style>
<style>
.transaction-dashboard-container {
  max-width: 600px;
  width: 100%;
}

.remove-container {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

@media screen and (max-width: 768px) {
  .remove-container {
    width: 30px !important;
  }

  .Fuell-ToolbarButton--badge {
    width: 30px !important;
  }
}

.large-dropdown .Fuell-Dropdown--container {
  position: absolute;
  width: 230px;
  text-align: left;
}

.large-dropdown .list-item {
  display: flex;
  justify-content: flex-start;
  margin: 10px 0px;
  border-bottom: 1px solid var(--fill-background);
}

.large-dropdown .list-item .icon {
  margin-right: 10px;
}

.icon-diet {
  max-width: 17px;
  max-height: 17px;
}

.Fuell-ToolbarButton.success {
  background-color: var(--success);
  color: var(--fill-main-background);
}

.Fuell-ToolbarButton.danger {
  background-color: var(--danger);
  color: var(--fill-main-background);
}

.dropdown--content {
  z-index: 12 !important;
}
</style>
